import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-neutral-600" }, [
  /*#__PURE__*/_createTextVNode("Please fill out all the required fields with the red asterisk ("),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "*"),
  /*#__PURE__*/_createTextVNode(")")
], -1)
const _hoisted_3 = { class: "grid grid-cols-2 gap-6 mt-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 border-t border-gray-200" }, null, -1)
const _hoisted_5 = { class: "col-span-2" }
const _hoisted_6 = { class: "col-span-2" }

import { ref } from 'vue';
import SectionTitle from '@/components/partials/SectionTitle.vue';
import TextInput from '@/components/inputs/TextInput.vue';

import { LocationDataInterface } from "@/interfaces/Settings/LocationInterface"


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
    form: {
        type: Object as () => LocationDataInterface,
        defualt: [],
        required: true,
    },
    errors: {
        type: Object,
        defualt: [],
        required: true,
    },
},
  setup(__props) {

const props = __props;

const form = ref<LocationDataInterface>(props.form);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SectionTitle, {
      fontSmall: "",
      title: "Region Information"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("form", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TextInput, {
          type: "text",
          label: "Region code",
          placeholder: "Region code",
          name: "code",
          id: "code",
          modelValue: form.value.code,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.code) = $event)),
          error: __props.errors?.code,
          required: ""
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(TextInput, {
          type: "text",
          label: "Region name",
          placeholder: "Region name",
          name: "name",
          id: "name",
          modelValue: form.value.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.name) = $event)),
          error: __props.errors?.name,
          required: ""
        }, null, 8, ["modelValue", "error"])
      ]),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})